import React from "react";
import { Slot } from "@radix-ui/react-slot";




/**
 * Botón reutilizable con estilos básicos y soporte para props estándar.
 * Props:
 * - children: contenido del botón
 * - onClick: función al hacer click
 * - type: tipo de botón (button, submit, etc.)
 * - className: clases adicionales para personalización
 * - ...rest: otros props estándar de button
 */
export function Button({ children, onClick, type = "button", className = "", ...rest }) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`min-w-max px-6 py-4 rounded bg-black text-white font-semibold hover:bg-gray-900 transition-colors focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 whitespace-nowrap ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
